import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

const SUFFIX = "Pronto alla Vendita";
const SEP = " | ";

// Static route -> page name mapping
const STATIC_TITLES = {
  "/": "Il Protocollo per la vendita immobiliare",
  "/chi-siamo": "Chi Siamo",
  "/perche": "Perché",
  "/perche-diventare-partner": "Perché diventare Partner",
  "/galleria": "La Galleria",
  "/agenzie": "Agenzie Partner",
  "/form": "Richiedi Valutazione",
  "/admin/login": "Area Riservata",
  "/admin": "Area Riservata",
  "/admin/agenzie": "Agenzie · Area Riservata",
  "/admin/tecnici": "Tecnici · Area Riservata",
  "/admin/immobili": "Immobili · Area Riservata",
  "/admin/leads": "Richieste Valutazione · Area Riservata",
  "/admin/registro-richieste": "Registro Richieste · Area Riservata",
  "/admin/richieste-documentazione": "Richieste Documentazione · Area Riservata",
  "/admin/audit": "Audit · Area Riservata",
  "/area-agenzie/login": "Area Agenzie",
  "/area-agenzie": "Area Agenzie",
  "/area-agenzie/immobili": "I miei Immobili · Area Agenzie",
  "/area-agenzie/richieste": "Richieste · Area Agenzie",
  "/area-agenzie/documentazione": "Documentazione · Area Agenzie",
  "/area-agenzie/profilo": "Profilo · Area Agenzie",
};

// Dynamic route patterns
const DYNAMIC_PATTERNS = [
  { pattern: "/immobile/:id", title: "Immobile" },
  { pattern: "/admin/immobili/:id", title: "Fascicolo Immobile · Area Riservata" },
];

export function formatTitle(page) {
  if (!page) return SUFFIX;
  return `${page}${SEP}${SUFFIX}`;
}

export default function usePageTitle(customTitle) {
  const location = useLocation();

  useEffect(() => {
    if (customTitle) {
      document.title = formatTitle(customTitle);
      return;
    }

    const path = location.pathname;
    let page = STATIC_TITLES[path];

    if (!page) {
      for (const { pattern, title } of DYNAMIC_PATTERNS) {
        if (matchPath(pattern, path)) {
          page = title;
          break;
        }
      }
    }

    document.title = page ? formatTitle(page) : SUFFIX;
  }, [location.pathname, customTitle]);
}
